import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";
import ensureSettingsCategoryOpen from "@app/component/flows/utils/ensureSettingsCategoryOpen";

const messages = defineMessages({
  initialSetup1: {
    id: "guides.gettingStarted.checklist.initialSetup.step1",
    defaultMessage: "Users and permissions",
  },
  initialSetup1Description: {
    id: "guides.gettingStarted.checklist.initialSetup.step1.description",
    defaultMessage: "Here you can manage your users, teams, and configure sharing options.",
  },
  initialSetup2: {
    id: "guides.gettingStarted.checklist.initialSetup.step2",
    defaultMessage: "Organization preferences",
  },
  initialSetup2Description: {
    id: "guides.gettingStarted.checklist.initialSetup.step2.description",
    defaultMessage:
      "Use this page to configure different organization settings, such as units, logo, access settings, etc.",
  },
  initialSetup3: {
    id: "guides.gettingStarted.checklist.initialSetup.step3",
    defaultMessage: "Activity types",
  },
  initialSetup3Description: {
    id: "guides.gettingStarted.checklist.initialSetup.step3.description",
    defaultMessage: "Here you can configure custom activity types and adjust their visibility.",
  },
  initialSetup4: {
    id: "guides.gettingStarted.checklist.initialSetup.step4",
    defaultMessage: "Notifications",
  },
  initialSetup4Description: {
    id: "guides.gettingStarted.checklist.initialSetup.step4.description",
    defaultMessage: "This is the notifications center, click the bell icon to proceed.",
  },
  initialSetup5: {
    id: "guides.gettingStarted.checklist.initialSetup.step5",
    defaultMessage: "Notifications",
  },
  initialSetup5Description: {
    id: "guides.gettingStarted.checklist.initialSetup.step5.description",
    defaultMessage:
      "Any notifications you have set can be found here, such as mentions or overdue activities.",
  },
});

export const ownersInitialSetupTour: TourDescriptor = {
  id: "getting-started-owners-initial-setup",
  steps: [
    {
      id: "user-management",
      description: messages.initialSetup1Description,
      onBefore: async () => {
        ensureSettingsCategoryOpen("organization");
      },
      position: "right",
      selector: "[data-menu-item=user-management]",
      title: messages.initialSetup1,
    },
    {
      id: "org-details",
      description: messages.initialSetup2Description,
      goToPathBefore: "/settings/organization/details",
      position: "right",
      selector: "[data-menu-item=org-details]",
      title: messages.initialSetup2,
    },
    {
      id: "activity-types",
      description: messages.initialSetup3Description,
      goToPathBefore: "/settings/organization/activity-types",
      position: "right",
      selector: "[data-menu-item=activity-types]",
      title: messages.initialSetup3,
    },
    {
      id: "notifications-button",
      description: messages.initialSetup4Description,
      options: {
        disableInteraction: false,
        showButtons: false,
      },
      selector: "[data-action-id=notification-center]",
      title: messages.initialSetup4,
      waitForEvent: {
        eventType: "click",
        selector: "[data-action-id=notification-center]",
      },
    },
    {
      id: "notifications-center",
      description: messages.initialSetup5Description,
      onAfter: async () => {
        (document.querySelector("[data-action-id=notification-center]") as HTMLElement)?.click();
      },
      selector: ".ant-popover[class*=Notifications_container]",
      title: messages.initialSetup5,
    },
  ],
};

export const managersInitialSetupTour: TourDescriptor = {
  id: "getting-started-managers-initial-setup",
  steps: [
    {
      id: "user-management",
      description: messages.initialSetup1Description,
      onBefore: async () => {
        ensureSettingsCategoryOpen("organization");
      },
      position: "right",
      selector: "[data-menu-item=user-management]",
      title: messages.initialSetup1,
    },
    {
      id: "notifications-button",
      description: messages.initialSetup4Description,
      options: {
        disableInteraction: false,
        showButtons: false,
      },
      selector: "[data-action-id=notification-center]",
      title: messages.initialSetup4,
      waitForEvent: {
        eventType: "click",
        selector: "[data-action-id=notification-center]",
      },
    },
    {
      id: "notifications-center",
      description: messages.initialSetup5Description,
      onAfter: async () => {
        (document.querySelector("[data-action-id=notification-center]") as HTMLElement)?.click();
      },
      selector: ".ant-popover[class*=Notifications_container]",
      title: messages.initialSetup5,
    },
  ],
};
